/* ================================================== */
/* ISOTOPE → init
/* ================================================== */

var grid;

function initIsotope() {
	// Init isotope
	grid = $('#works .row-flex').isotope({
		masonry           : {
			columnWidth: '.work-sizer',
			gutter     : '.gutter-sizer'
		},
		itemSelector      : '.work-item',
		percentPosition   : true,
		stamp             : '.work-logo',
		transitionDuration: 0,
		getSortData       : {
			rsort: function(itemElem) {
				var rsort = $(itemElem).data('rsort');
				return parseFloat(rsort);
			}
		}
	});

	grid.on('arrangeComplete', function() {
		setTimeout(function(){
			$('.homepage #works').fadeTo(300, 1);
		}, 300);
	});

	// Init filter
	var sortPhoto = (workFilter == 'photo') ? false : 'rsort';
	var sortOther = (workFilter == 'photo') ? 'rsort' : false;

	$('ul.filter a').click(function(e) {
		e.preventDefault();

		var cat  = $(this).parent().data('filter'),
			mode = $(this).parent().data('mode');

		window.history.pushState(null, null, '?filter=' + mode);

		$('[data-filter] > a').removeClass('on');
		$('[data-filter="' + cat + '"] > a').addClass('on');

		grid.isotope({
			filter: (cat != '*') ? '.' + cat : cat,
			sortBy: (cat === 'works-photo') ? sortPhoto : sortOther
		});

		$(window).trigger('resize');
		setPostersHeights();

		$('html, body').animate({ scrollTop: 0 }, 400);
	});

	// Set default filter
	if (workFilter != '') {
		$('ul.filter li[data-filter="works-' + workFilter + '"] a').click();
	}
}

// Ready
$(document).ready(initIsotope());

// Resize
$(window).resize(function() {
	grid.isotope('layout', function(){});
});